export default __webpack_public_path__ + "static/media/LogoMain.c38215ba.svg";